import { Link } from "react-router-dom";

export const LogoMark = ({ size = 40 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <defs>
            <clipPath id="logo-round">
                <rect width="64" height="64" rx="14" />
            </clipPath>
        </defs>
        <g clipPath="url(#logo-round)">
            <rect width="64" height="64" fill="#FF3B30" />
            <g fill="#0B0C10">
                <path d="M0 64 L14 50 h8 L8 64 Z" />
                <path d="M16 64 L30 50 h8 L24 64 Z" />
                <path d="M32 64 L46 50 h8 L40 64 Z" />
                <path d="M48 64 L62 50 h2 v6 L56 64 Z" />
            </g>
            <text
                x="32"
                y="42"
                fontFamily="Arial, sans-serif"
                fontSize="40"
                fontWeight="900"
                fill="#FFFFFF"
                textAnchor="middle"
            >
                $
            </text>
        </g>
    </svg>
);

export const Logo = () => (
    <Link
        to="/"
        data-testid="header-logo"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="flex items-center gap-3 group"
    >
        <div className="transition-transform duration-300 group-hover:-rotate-6">
            <LogoMark size={42} />
        </div>
        <div className="leading-none">
            <span className="block font-display font-extrabold text-[#141721] text-base tracking-tight uppercase">
                Toronto Scrap
            </span>
            <span className="block font-display font-bold text-[#FF3B30] text-xs tracking-[0.22em] uppercase">
                Car Removal
            </span>
        </div>
    </Link>
);
